/**
 * Configurable Logger
 * Provides structured logging with log levels
 */

const LOG_LEVELS = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  silent: 4
};

export class Logger {
  constructor(level = 'info', prefix = '[VoiceMate]') {
    this.level = LOG_LEVELS[level] || LOG_LEVELS.info;
    this.prefix = prefix;
  }

  setLevel(level) {
    this.level = LOG_LEVELS[level] || LOG_LEVELS.info;
  }

  debug(...args) {
    if (this.level <= LOG_LEVELS.debug) {
      console.debug(this.prefix, ...args);
    }
  }

  info(...args) {
    if (this.level <= LOG_LEVELS.info) {
      console.info(this.prefix, ...args);
    }
  }

  warn(...args) {
    if (this.level <= LOG_LEVELS.warn) {
      console.warn(this.prefix, ...args);
    }
  }

  error(...args) {
    if (this.level <= LOG_LEVELS.error) {
      console.error(this.prefix, ...args);
    }
  }

  /**
   * Structured logging for important events
   * @param {string} eventName - Event name
   * @param {Object} data - Event data
   */
  event(eventName, data = {}) {
    if (this.level <= LOG_LEVELS.info) {
      console.info(this.prefix, `[EVENT: ${eventName}]`, data);
    }
  }
}
